import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar
} from '@ionic/react'
import React from 'react'
import { connect } from 'react-redux'
import Note from '../../components/note'
import Contract from '../../components/online-ordner/contract'
import withAuth from '../../components/with.auth'
import { State } from '../../store'
import { ProfileContract } from '../../store/auth'

interface DispatchProps {}

interface StateProps {
  contracts: ProfileContract[]
}

type Props = StateProps & DispatchProps

const Contracts: React.FC<Props> = props => {
  console.log('contracts', props.contracts)

  return (
    <IonPage color={'primary'}>
      <IonHeader>
        <IonToolbar color={'primary'}>
          <IonButtons slot="start">
            <IonMenuButton autoHide={false} />
          </IonButtons>
          <IonTitle>Verträge</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent
        className="ion-padding no-footer"
        color={'background'}
      >
        {props.contracts.length === 0 && (
          <Note>
            Keine Verträge verfügbar
          </Note>
        )}

        {props.contracts.map(contract => <Contract contract={contract} key={contract.contract_id} />)}
      </IonContent>
    </IonPage>
  )
}

export default withAuth(connect<StateProps, DispatchProps, {}, State>(
  ({auth}) => ({
    contracts: auth.contracts
  }),
  {}
)(Contracts))
